import script from "./MyUploadFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyUploadFile.vue?vue&type=script&setup=true&lang=ts"

import "./MyUploadFile.vue?vue&type=style&index=0&id=3956c02d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3956c02d"]])

export default __exports__